const BASE_URL = process.env.NODE_ENV === 'production' 
  ? '/api' 
  : 'http://localhost:5500/api';

// Track Marathi visit
export const trackMarathiVisit = async (customPath = null) => {
  try {
    const path = customPath || window.location.pathname;
    
    const response = await fetch(`${BASE_URL}/marathivisits/track`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        path: path || '/',
        timestamp: new Date().toISOString()
      })
    });

    if (!response.ok) {
      console.warn('Failed to track visit, but continuing...');
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.warn('Visit tracking error (non-critical):', error);
    // Don't throw error - visit tracking shouldn't break the app
    return { success: false };
  }
};

// Track page changes for specific routes
export const trackPageView = (path) => {
  // Track in your database
  trackMarathiVisit(path);
  
  // Optional: Also track with Google Analytics if you have it
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', 'YOUR_GA_ID', {
      page_path: path,
    });
  }
};

export default {
  trackMarathiVisit,
  trackPageView
};